const fieldStyles = {
  UNDERLINE: 'underline',
  OUTLINE:   'outline',
  SOLID:     'solid',
};

const fieldStylesList = [
  { text: 'Underline', value: fieldStyles.UNDERLINE },
  { text: 'Outline', value: fieldStyles.OUTLINE },
  { text: 'Solid', value: fieldStyles.SOLID },
];

const fieldStylesAll = _.values(fieldStyles);

export { fieldStyles, fieldStylesList, fieldStylesAll };

export default fieldStyles;
